import { apiUtils } from '../hooks';
import { User } from '../types';
import { throwApiError } from '../utils';
import { API_ENDPOINTS } from './apiEndpoints';

class UsersService {
  // Methods for user management
  async getUsers() {
    try {
      const response = await apiUtils.get<User[]>(API_ENDPOINTS.users.list);
      return response.data;
    } catch (error) {
      throwApiError(error, 'Failed to fetch users');
    }
  }

  async getUserById(id: string) {
    try {
      const response = await apiUtils.get<User>(API_ENDPOINTS.users.detail(id));
      return response.data.data;
    } catch (error) {
      throwApiError(error, `Failed to fetch user with id: ${id}`);
    }
  }

  async createUser(userData: Partial<User>) {
    try {
      const response = await apiUtils.post<User>(
        API_ENDPOINTS.users.create,
        userData
      );
      return response.data;
    } catch (error) {
      throwApiError(error, 'Failed to create user');
    }
  }

  async updateUser(id: string, userData: Partial<User>) {
    try {
      const response = await apiUtils.put<User>(
        API_ENDPOINTS.users.update(id),
        userData
      );
      return response.data;
    } catch (error) {
      throwApiError(error, `Failed to update user with id: ${id}`);
    }
  }
  async deleteUser(id: string) {
    try {
      await apiUtils.delete(API_ENDPOINTS.users.delete(id));
    } catch (error) {
      throwApiError(error, `Failed to delete user with id: ${id}`);
    }
  }

  async activateUser(id: string) {
    try {
      const response = await apiUtils.patch<User>(
        API_ENDPOINTS.users.activateUser(id)
      );
      return response.data;
    } catch (error) {
      throwApiError(error, `Failed to activate user with id: ${id}`);
    }
  }
  async deactivateUser(id: string) {
    try {
      const response = await apiUtils.patch<User>(
        API_ENDPOINTS.users.deactivateUser(id)
      );
      return response.data;
    } catch (error) {
      throwApiError(error, `Failed to deactivate user with id: ${id}`);
    }
  }

  async getRoles() {
    try {
      const response = await apiUtils.get<string[]>(API_ENDPOINTS.users.getRoles);
      return response.data;
    } catch (error) {
      throwApiError(error, 'Failed to fetch user roles');
    }
  }

  async agreeToTerms() {
    try {
      await apiUtils.patch(API_ENDPOINTS.users.agreeTerms);
    } catch (error) {
      throwApiError(error, 'Failed to agree to terms');
    }
  }
  // async disagreeToTerms() {
  //   try {
  //     await apiUtils.post(API_ENDPOINTS.users.disagreeTerms);
  //   } catch (error) {
  //     throwApiError(error, 'Failed to disagree to terms');
  //   }
  // }
}
const usersService = new UsersService();
export default usersService;
